var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50781 4.75C1.50781 4.33579 1.8436 4 2.25781 4H16.1328C16.547 4 16.8828 4.33579 16.8828 4.75C16.8828 5.16421 16.547 5.5 16.1328 5.5H15.3828V9.25C15.3828 9.66421 15.047 10 14.6328 10H10.1328V14.5H11.6328C12.047 14.5 12.3828 14.8358 12.3828 15.25C12.3828 15.6642 12.047 16 11.6328 16H7.13281C6.7186 16 6.38281 15.6642 6.38281 15.25C6.38281 14.8358 6.7186 14.5 7.13281 14.5H8.63281V10H4.13281C3.7186 10 3.38281 9.66421 3.38281 9.25V5.5H2.25781C1.8436 5.5 1.50781 5.16421 1.50781 4.75ZM13.8828 8.5V5.5H4.88281V8.5H13.8828Z",
    fill: "#3F73F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9245 16.2499C14.9245 16.7102 15.2976 17.0833 15.7578 17.0833C16.218 17.0833 16.5911 16.7102 16.5911 16.2499V14.7916H18.0495C18.5097 14.7916 18.8828 14.4185 18.8828 13.9583C18.8828 13.498 18.5097 13.1249 18.0495 13.1249L16.5911 13.1249V11.6666C16.5911 11.2063 16.218 10.8333 15.7578 10.8333C15.2976 10.8333 14.9245 11.2063 14.9245 11.6666V13.1249L13.4661 13.1249C13.0059 13.1249 12.6328 13.498 12.6328 13.9583C12.6328 14.4185 13.0059 14.7916 13.4661 14.7916H14.9245V16.2499Z",
    fill: "#3F73F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.bdffa5b096a98a9600f7b4649e7041dd.svg";
export { ForwardRef as ReactComponent };